import React from 'react';
import './Testimonials.css';

const Testimonials = () => {
  const testimonials = [
    {
      name: 'Daniel McAvoy',
      content: 'I would like to say big "Thank you" to SkylinesteelDesign TEAM for immense effort and support. In addition, I have feeling that our future projects are going to be great as well, good luck to the Team.',
      rating: 5
    },
    {
      name: 'Mark Tiner',
      content: 'I\'ve been working with these guys for a long time and I can say that our projects are in the perfect hands.',
      rating: 5
    },
    {
      name: 'Edward Glenn',
      content: 'SkylinesteelDesign team did a fantastic project, they were quick, efficient and very professional.',
      rating: 5
    }
  ];

  return (
    <section className="testimonials" id="testimonials">
      <div className="container">
        <h2 className="section-title">What Our Clients Say</h2>
        <p className="testimonials-subtitle">
          Trusted by industry leaders worldwide for exceptional steel solutions
        </p>
        <div className="testimonials-grid">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="testimonial-card">
              <div className="testimonial-rating">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <span key={i} className="star">⭐</span>
                ))}
              </div>
              <blockquote className="testimonial-content">
                "{testimonial.content}"
              </blockquote>
              <div className="testimonial-author">
                <h4 className="author-name">{testimonial.name}</h4>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;

